var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messageTips"},[_c('div',{staticClass:"tips-font"},[(_vm.qffMessage.type === 'success')?_c('i',{staticClass:"successIcon"}):(_vm.qffMessage.type === 'warning')?_c('i',{staticClass:"warningIcon"}):(_vm.qffMessage.type === 'none')?_c('i',{staticClass:"noneIcon"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.qffMessage.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }